import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type PatientEventType =
  | "careplan_renewed"
  | "did_not_start"
  // TODO STE-1609: remove 'careplan_deleted' once backend fully migrated to 'did_not_start'
  | "careplan_deleted"
  | "doctor_decided_not_to_renew"
  | "care_plan_interrupted"
  | "aircall_sms_from_patient"
  | "aircall_sms"
  | "aircall_call_not_answered"
  | "aircall_call_answered"
  | "rpm_started"
  | "deceased"
  | "nurse_reinclusion_requested"
  | "nurse_reinclusion_cancelled"
  | "nurse_reinclusion_refused";

export type CarePlanInterruptionKind = "future" | "past" | "cancelled";

type PatientEventPayload = {
  stoppedBeforeCpEnd?: boolean;
  duration?: number;
  endDate?: string;
  kind?: CarePlanInterruptionKind;
};

const patientEventPayloadSchema: Schema<PatientEventPayload> = cz.camelCaseObject({
  stopped_before_cp_end: cz.optional(z.boolean()),
  duration: cz.optional(z.number()),
  end_date: cz.optional(z.string()),
  kind: cz.optional(z.literal(["future", "past", "cancelled"])),
});

export type PatientEvent = {
  id: string;
  eventType: PatientEventType;
  createdAt: string;
  authorFirstName?: string;
  authorLastName?: string;
  authorId?: string;
  payload?: PatientEventPayload;
};

export const patientEventsSchema: Schema<PatientEvent> = cz.camelCaseObject({
  id: z.string(),
  event_type: z.literal([
    "careplan_renewed",
    "did_not_start",
    // TODO STE-1609: remove 'careplan_deleted' once backend fully migrated to 'did_not_start'
    "careplan_deleted",
    "doctor_decided_not_to_renew",
    "care_plan_interrupted",
    "aircall_sms",
    "aircall_sms_from_patient",
    "aircall_call_not_answered",
    "aircall_call_answered",
    "rpm_started",
    "deceased",
    "nurse_reinclusion_requested",
    "nurse_reinclusion_cancelled",
    "nurse_reinclusion_refused",
  ]),
  created_at: z.string(),
  author_first_name: cz.optional(z.string()),
  author_last_name: cz.optional(z.string()),
  author_id: cz.optional(z.string()),
  payload: cz.optional(patientEventPayloadSchema),
});
